import { render } from "./SiteTitle.vue?vue&type=template&id=4cce1bbd"
import script from "./SiteTitle.vue?vue&type=script&lang=js"
export * from "./SiteTitle.vue?vue&type=script&lang=js"

import "./SiteTitle.vue?vue&type=style&index=0&id=4cce1bbd&lang=postcss"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__